export default __webpack_public_path__ + "static/media/gate.056c942f.jpg";